import React, { useEffect } from 'react';
import { colors, spacing, borderRadius, typography, shadows, transition } from '@serps/ui-kit/src/tokens';

export type ToastVariant = 'success' | 'error';

interface Props {
  message:   string;
  variant:   ToastVariant;
  onDismiss: () => void;
}

const ACCENT: Record<ToastVariant, string> = {
  success: '#22c55e',
  error:   '#ef4444',
};

const ICON: Record<ToastVariant, string> = {
  success: '✓',
  error:   '✕',
};

export function Toast({ message, variant, onDismiss }: Props) {
  useEffect(() => {
    const t = setTimeout(onDismiss, 4000);
    return () => clearTimeout(t);
  }, [onDismiss]);

  const accent = ACCENT[variant];

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position:        'fixed',
        top:             spacing.xl,
        right:           spacing.xl,
        zIndex:          2000,
        display:         'flex',
        alignItems:      'flex-start',
        gap:             spacing.sm,
        backgroundColor: colors.neutral.charcoal,
        border:          `1.5px solid ${accent}`,
        borderRadius:    borderRadius.lg,
        padding:         `${spacing.sm} ${spacing.md}`,
        boxShadow:       shadows.xl,
        maxWidth:        '360px',
        transition:      transition.fast,
      }}
    >
      <span
        style={{
          display:         'inline-flex',
          alignItems:      'center',
          justifyContent:  'center',
          width:           '22px',
          height:          '22px',
          borderRadius:    '50%',
          backgroundColor: accent,
          color:           '#fff',
          fontSize:        '12px',
          fontWeight:      'bold',
          flexShrink:      0,
          marginTop:       '1px',
        }}
        aria-hidden
      >
        {ICON[variant]}
      </span>

      <p style={{ margin: 0, flex: 1, fontSize: typography.fontSize.sm, color: colors.neutral.white, lineHeight: 1.5 }}>
        {message}
      </p>

      <button
        onClick={onDismiss}
        aria-label="Tutup / Close"
        style={{
          background:   'none',
          border:       'none',
          cursor:       'pointer',
          color:        colors.neutral.gray400,
          fontSize:     '16px',
          lineHeight:   1,
          padding:      0,
          flexShrink:   0,
          marginTop:    '1px',
        }}
      >
        ×
      </button>
    </div>
  );
}
